import React from "react";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { queryOps } from "system/query/Query";
import { QueryBuilderContainerBox } from "components/queries/queryBuilder/common/QueryBuilderContainerBox";
import { QueryBuilderLabel } from "components/queries/queryBuilder/common/QueryBuilderLabel";
import { colorsAndLabelsByOp } from "system/query/QueryUtility";
import { QuerySpan } from "system/query/QuerySpan";
import QuerySegmentContainer, { QuerySegmentProps, spanSide } from "../../common/QuerySegmentContainer";
import { QueryBuilderFieldLabel } from "../../common/QueryBuilderFieldLabel";
import { QueryBuilderInnerLabel } from "../../common/QueryBuilderInnerLabel";

export interface QuerySpanViewerProps extends QuerySegmentProps {
  querySpan: QuerySpan;
}

export default function QuerySpanViewer(props: QuerySpanViewerProps): JSX.Element {
  const theme = useTheme();
  const {i18n} = useTranslation();

  const { backgroundColor, borderColor, borderColorTop, label } = colorsAndLabelsByOp(i18n, theme.colors.namedColors, queryOps.span);

  return (
    <QueryBuilderContainerBox
      path={props.path}
      draggable={props.path?.length > 0}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      borderColorTop={borderColorTop} >
      <QueryBuilderInnerLabel>{label}</QueryBuilderInnerLabel>
      <QueryBuilderFieldLabel
        queryInfo={props.queryInfo}
        isViewerMode={true}
        fieldId={props.querySpan.field}
        borderColor={borderColor}
        borderColorTop={borderColorTop}
        inline={true} />
      {props.querySpan.left &&
        <QuerySegmentContainer
        depth={props.depth + 1}
        parent={props.querySpan}
        path={`${props.path}.left`}
        inSpan={true}
        spanSide={spanSide.left}
        queryInfo={props.queryInfo}
        isViewerMode={true}
        querySegment={props.querySpan.left}
        editSegment={props.editSegment}
        addSegment={props.addSegment} />
      }
      <QueryBuilderInnerLabel>
        {props.querySpan.ordered &&
          <strong>{i18n.t("query-form.within-span-ordered", {distance: props.querySpan.distance})}</strong>
        }
        {!props.querySpan.ordered &&
          <strong>{i18n.t("query-form.within-span", {distance: props.querySpan.distance})}</strong>
        }
      </QueryBuilderInnerLabel>
      {props.querySpan.right &&
        <QuerySegmentContainer
          depth={props.depth + 1}
          parent={props.querySpan}
          path={`${props.path}.right`}
          inSpan={true}
          spanSide={spanSide.right}
          queryInfo={props.queryInfo}
          isViewerMode={true}
          querySegment={props.querySpan.right}
          editSegment={props.editSegment}
          addSegment={props.addSegment} />
      }
    </QueryBuilderContainerBox>
  );
}